import { Injectable } from "@angular/core";
import { BaseService } from "../base.service";
import {
  IResourceMethod,
  ResourceAction,
  ResourceParams,
  ResourceRequestMethod,
} from "@ngx-resource/core";

/**
 Class for the UserService.
 */

export interface IUser {
  id?: number;
  name?: string;
  email?: string;
  access_token?: string;
  is_active?: number;
  access_level?: string;
  created_at?: string;
  updated_at?: string;
}

@Injectable()
@ResourceParams({
  url: BaseService.BASE_URL + "/v1/users",
})
export class UserService extends BaseService {
  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: "/login",
    skipAuthorization: true,
  })
  login: IResourceMethod<{ email: string; password: string }, IUser>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: "/recover-password",
    skipAuthorization: true,
  })
  recoverPassword: IResourceMethod<{ email: string; password: string }, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: "/reset-password",
    skipAuthorization: true,
  })
  resetPassword: IResourceMethod<{ password: string; 'password-reset-token': string }, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
  })
  save: IResourceMethod<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Put,
    path: "/{!id}",
  })
  update: IResourceMethod<any, any>;

  @ResourceAction({
    path: "/{!id}",
  })
  get: IResourceMethod<any, any>;

  @ResourceAction({
    isArray: true,
  })
  query: IResourceMethod<any, any[]>;

  @ResourceAction({
    method: ResourceRequestMethod.Delete,
    path: "/{!id}",
  })
  remove: IResourceMethod<{ id: any }, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: "/change-password",
  })
  changePassword: IResourceMethod<{ id: any }, any>;
}



// WEBPACK FOOTER //
// ./src/app/core/api/user/client.service.ts